export const FILE_STATUS_OPTIONS = [
  'NUEVO PEDIDO',
  'LAST MINUTE',
  'REVISAR',
  'ANULADO',
  'POSTERGADO',
  'EN PROCESO',
  'CONFIRMADO',
  'RECONFIRMADO',
  'PROGRAMADO',
  'EN OPERACION',
  'OPERADO',
  'CERRADO'
] as const;

export interface FileDisplayStateInput {
  pendingPreOpIncidents?: number | null;
  estadoFile?: string | null;
  estadoItinerario: string;
  lastMinute?: string | null;
}

export const getFileDisplayState = ({
  pendingPreOpIncidents,
  estadoFile = null,
  estadoItinerario,
  lastMinute
}: FileDisplayStateInput): string => {
  if (pendingPreOpIncidents != null && pendingPreOpIncidents > 0) {
    return 'REVISAR';
  }

  if (
    (estadoFile === 'RECONFIRMADO' || estadoFile === 'NUEVO PEDIDO') &&
    lastMinute &&
    lastMinute !== 'Desactivado'
  ) {
    return 'LAST MINUTE';
  }

  if (estadoFile != null) {
    return estadoFile;
  }

  return estadoItinerario;
};

export const getFileRowClass = (state: string | null | undefined): string => {
  if (state === 'LAST MINUTE') return 'row-last-minute';
  if (state === 'REVISAR') return 'row-revisar';
  return '';
};

export const getFileStatusPillClass = (state: string | null | undefined): string => {
  const classesByState: Record<string, string> = {
    'NUEVO PEDIDO': 'pill-nuevo',
    'LAST MINUTE': 'pill-urgente',
    REVISAR: 'pill-revisar',
    ANULADO: 'pill-anulado',
    POSTERGADO: 'pill-postergado',
    'EN PROCESO': 'pill-proceso',
    CONFIRMADO: 'pill-confirmado',
    RECONFIRMADO: 'pill-reconfirmado',
    PROGRAMADO: 'pill-programado',
    'EN OPERACION': 'pill-operacion',
    OPERADO: 'pill-operado',
    CERRADO: 'pill-cerrado',
    FILE: 'pill-file'
  };

  return classesByState[state ?? ''] ?? 'pill-file';
};

export const getNextFileState = (currentState: string | null | undefined): string => {
  const nextStateByCurrentState: Record<string, string> = {
    'NUEVO PEDIDO': 'EN PROCESO',
    'EN PROCESO': 'CONFIRMADO',
    RECONFIRMADO: 'PROGRAMADO',
    PROGRAMADO: 'EN OPERACION',
    'EN OPERACION': 'OPERADO',
    OPERADO: 'CERRADO'
  };

  return nextStateByCurrentState[currentState ?? ''] ?? '';
};
